import { Brand, BrandsResponse } from '../types';

const brandRows: Brand[] = [
  {
    id: 'brand_1',
    name: 'tradingbase',
    display_name: 'tradingbase',
    tracked_names: ['tradingbase'],
    domains: ['tradingbase.ai'],
    mentions: 0,
    color: 'zinc',
    is_own: true,
    is_active: true,
  },
  {
    id: 'brand_2',
    name: 'Robinhood',
    display_name: 'Robinhood',
    tracked_names: ['Robinhood'],
    domains: ['robinhood.co.th'],
    mentions: 561,
    color: 'amber',
    is_active: true,
  },
  {
    id: 'brand_3',
    name: 'thinkorswim',
    display_name: 'thinkorswim',
    tracked_names: ['thinkorswim'],
    domains: ['thinkorswim.com'],
    mentions: 166,
    color: 'emerald',
    is_active: true,
  },
  {
    id: 'brand_4',
    name: 'TradingView',
    display_name: 'TradingView',
    tracked_names: ['TradingView'],
    domains: ['tradingview.com'],
    mentions: 126,
    color: 'sky',
    is_active: true,
  },
  {
    id: 'brand_5',
    name: 'eToro',
    display_name: 'eToro',
    tracked_names: ['eToro'],
    domains: ['etoro.com'],
    mentions: 88,
    color: 'emerald',
    is_active: true,
  },
  {
    id: 'brand_6',
    name: 'ProRealTime',
    display_name: 'ProRealTime',
    tracked_names: ['ProRealTime'],
    domains: ['prorealtime.com'],
    mentions: 2,
    color: 'zinc',
    is_active: true,
  },
  {
    id: 'brand_7',
    name: 'Kite',
    display_name: 'Kite',
    tracked_names: ['Kite'],
    domains: ['kite.trade'],
    mentions: 1,
    color: 'sky',
    is_active: true,
  },
  {
    id: 'brand_8',
    name: 'Dotbig',
    display_name: 'Dotbig',
    tracked_names: ['Dotbig'],
    domains: ['dotbig.com'],
    mentions: 0,
    color: 'violet',
    is_active: true,
  },
  {
    id: 'brand_9',
    name: 'Trader Breeder',
    display_name: 'Trader Breeder',
    tracked_names: ['Trader Breeder'],
    domains: ['traderbreeder.com'],
    mentions: 0,
    color: 'zinc',
    is_active: true,
  },
];

export const mockBrandsData: BrandsResponse = {
  total: brandRows.length,
  page: 1,
  limit: 20,
  trial_ends_in_days: 6,
  data: brandRows,
  suggestions: [
    {
      id: 'suggestion_1',
      name: 'Webull',
      domain: 'webull.com',
      mentions: 301,
      status: 'pending',
    },
    {
      id: 'suggestion_2',
      name: 'Charles Schwab',
      domain: 'schwab.com',
      mentions: 239,
      status: 'pending',
    },
    {
      id: 'suggestion_3',
      name: 'Interactive Brokers',
      domain: 'interactivebrokers.com',
      mentions: 216,
      status: 'pending',
    },
    {
      id: 'suggestion_4',
      name: 'Fidelity Investments',
      domain: 'fidelity.com',
      mentions: 185,
      status: 'pending',
    },
    {
      id: 'suggestion_5',
      name: 'Fidelity',
      domain: 'fidelitybanknc.com',
      mentions: 157,
      status: 'pending',
    },
    {
      id: 'suggestion_6',
      name: 'Moomoo',
      domain: 'moomoo.com',
      mentions: 102,
      status: 'pending',
    },
    {
      id: 'suggestion_7',
      name: 'Betterment',
      domain: 'betterment.com',
      mentions: 89,
      status: 'pending',
    },
    {
      id: 'suggestion_8',
      name: 'Acorns',
      domain: 'acorns.com',
      mentions: 86,
      status: 'pending',
    },
    {
      id: 'suggestion_9',
      name: 'SoFi',
      domain: 'sofi.com',
      mentions: 62,
      status: 'pending',
    },
    {
      id: 'suggestion_10',
      name: 'Public',
      domain: 'public.com',
      mentions: 58,
      status: 'pending',
    },
    {
      id: 'suggestion_11',
      name: 'Tastytrade',
      domain: 'tastytrade.com',
      mentions: 51,
      status: 'pending',
    },
  ]
};
